import { render } from "./ImpreparationView.vue?vue&type=template&id=64d91c57&scoped=true"
import script from "./ImpreparationView.vue?vue&type=script&lang=js"
export * from "./ImpreparationView.vue?vue&type=script&lang=js"

import "./ImpreparationView.vue?vue&type=style&index=0&id=64d91c57&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d91c57"]])

export default __exports__